import { FunctionComponent, PropsWithChildren, useCallback } from "react";
import { ErrorBoundary } from "@sentry/react";

const MarketplaceWidgetErrorBoundary: FunctionComponent<PropsWithChildren> = (props) => {
    const fallbackRender = useCallback(() => (
        <div className="MarketplaceWidgetErrorBoundary">
            ERROR!
        </div>
    ), []);

    return (
        <ErrorBoundary fallback={fallbackRender} onError={(err, stack, id) => console.error(err, stack, id)}>
            {props.children}
        </ErrorBoundary>
    );
}

export default MarketplaceWidgetErrorBoundary;